import { CALL_PAGE } from "../common/constants"

import { Spinner } from "components/Spinner"
import { useGetBookingHash } from "modules/Call/routing"
import { Analytics } from "utils/analytics"
import { useGetPsyCall } from "modules/Call/queries"
import { resolveRedirect } from "modules/Call/PsyRedirects"
import { EndedForm } from "modules/Call/components/EndedForm"
import { useDidMount } from "utils/customHooks"

export function PsyCallEndedPage() {
    const bookingHash = useGetBookingHash(true)
    const { isFetching, data } = useGetPsyCall(bookingHash, CALL_PAGE.ENDED, false)

    useDidMount(() => Analytics.after_nextstep_loaded())

    if (isFetching || !data) return <Spinner />

    const redirect = resolveRedirect(data.status, CALL_PAGE.ENDED)
    if (redirect) return redirect({ bookingHash: bookingHash })

    return (
        <EndedForm
            header={
                <>
                    Сессия завершена.
                    <br />
                    Запишите клиента на&nbsp;следующую
                </>
            }
            header2="Если вы договорились, вы можете записать клиента уже сейчас"
            user={{
                name: data.booking.client.name,
                titles: ["Ваш клиент"],
            }}
            primaryButton={{
                text: "Записать на следующую",
                onClick: () => {
                    Analytics.after_nextstep_booknext()
                    document.location = `/psychologist-account/clients/${data.booking.client.id}/book-session?position=call`
                },
            }}
            secondaryButton={{
                text: "К моему расписанию",
                onClick: () => {
                    Analytics.after_nextstep_viewcalendar()
                    document.location = `/psychologist-account/calendar`
                },
            }}
        />
    )
}
